import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";
import { PnlComponent } from "./pnl.component";

export class HaltedNotificationComponent implements IComponent {
    public id = '';

    public element: HTMLElement;
    private base: IChartContainer;
    
    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.base = base;
        this.subscribeHaltedNotificationData();
    }

    public show() {
        this.element.removeClass('hidden');
        this.checkPnlBox();
    }

    public hide() {
        this.element.addClass('hidden');
        this.checkPnlBox();
    }

    private checkPnlBox() {
        const comp = this.base.getComponentsByType(PnlComponent)?.[0] as PnlComponent;
        if (comp) {
            comp.addOneClass();
        }
    }

    private updateTitle(description: string) {
        this.element.setAttribute('title', description);
    }

    private subscribeHaltedNotificationData() {
        this.base.chartService.subscribeHaltedNotificationData((showNotification: boolean, description: string) => {
            if (showNotification) {
                this.show();
            } else {
                this.hide();
            }
            this.updateTitle(description);
        });
    }
}